import { render } from "./FiltersAccordion.vue?vue&type=template&id=5a82c503&scoped=true"
import script from "./FiltersAccordion.vue?vue&type=script&lang=js"
export * from "./FiltersAccordion.vue?vue&type=script&lang=js"

import "./FiltersAccordion.vue?vue&type=style&index=0&id=5a82c503&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a82c503"]])

export default __exports__